export default __webpack_public_path__ + "static/media/Flaticon.2eb31b97.woff2";